// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner___K3TC","errorLogs":"styles_errorLogs__1LT-k"};